import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {Guid} from "../../../../helpers/guid-helper";

@Component({
  selector: 'cqme-checkbox',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent {
  @Input() id: any = Guid.newGuid();

  @Input() checked: boolean = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  @Input() disabled: boolean = false;

  @Input() label: string = "";
  protected readonly alert = alert;
}
